import React from "react";
import $ from 'jquery';
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {authLogout} from "../../../modules/Admin/User/Login/store/actions";
import AdminAccountInvoker from "./AdminAccountInvoker";
import TopBarSettings from "./TopBarSettings";
import { urlConfigs } from '../../../configs/config'

const TopBar = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isCompany = useSelector(state => state.userMeta?.meta?.is_company);

    const logout = () => {
        dispatch(authLogout());
        localStorage.setItem('userToken', '');
        history.replace("/admin/login");
    };

    return (
        <div className="navbar navbar-inverse">
            <div className="navbar-header">
                <a className="navbar-brand" href={urlConfigs.LOCAL_URL}><img
                    src="/logo.png" alt=""/></a>

                <ul className="nav navbar-nav visible-xs-block">
                    <li><a data-toggle="collapse" data-target="#navbar-mobile"><i className="icon-tree5"/></a></li>
                    <li><a className="sidebar-mobile-main-toggle"><i className="icon-paragraph-justify3" /></a></li>
                    <li><a className="sidebar-mobile-opposite-toggle"><i className="icon-indent-decrease2" /></a></li>
                </ul>
            </div>

            <div className="navbar-collapse collapse" id="navbar-mobile">
                <ul className="nav navbar-nav">
                    <li><a className="sidebar-control sidebar-main-toggle hidden-xs"><i
                        className="icon-paragraph-justify3"/></a>
                    </li>
                </ul>

                <ul className="nav navbar-nav navbar-right navbar-top-settings">
                    {isCompany ? <TopBarSettings/> : <AdminAccountInvoker/>}

                    <li>
                        <a className="btn-logout" onClick={logout}>
                            Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    );
};

export default TopBar;

export const hideMenuMobile = () => {
    const htmlBody = $('body');
    const mobileMenuMainClass = 'sidebar-mobile-main';
    const mobileMenuIndicatorClass = 'sidebar-xs-indicator';
    const isMobile = $(window).width() < 769;

    if (isMobile) {
        if (htmlBody.attr('class').includes(mobileMenuMainClass)) {
            htmlBody.removeClass(mobileMenuMainClass);
        }
        if (htmlBody.attr('class').includes(mobileMenuIndicatorClass)) {
            htmlBody.removeClass(mobileMenuIndicatorClass);
        }
    }
};
